// extracted by mini-css-extract-plugin
export default {"main":"StudyRequest_main__7eWEU","header":"StudyRequest_header__OKnBZ","background":"StudyRequest_background__dMMb6","logo":"StudyRequest_logo__wx8Te"};